import React, { ComponentProps, memo } from 'react'

import { Box, FlexBox, Loader, Title, useLayerManager } from '@surglogs-app/ui'

interface DialogLoaderProps extends ComponentProps<typeof Box> {
  fullscreen?: boolean
}

export const DialogLoader = memo(
  ({
    fullscreen = false,
    children,
    bgc = 'transparent.90',
    ...rest
  }: DialogLoaderProps) => {
    const { zIndex, increaseBy } = useLayerManager()
    return (
      <Box
        {...{
          position: fullscreen ? 'fixed' : 'absolute',
          top: '0',
          bra: 'md',
          left: '0',
          right: '0',
          bottom: '0',
          bgc,
          zi: zIndex + increaseBy / 2,
          ...rest,
        }}>
        {children ? (
          <FlexBox {...{ h: '100%', ai: 'center', jc: 'center', pb: 'xxl' }}>
            <Title {...{ mb: 'xl' }}>{children}</Title>
          </FlexBox>
        ) : null}
        <Loader />
      </Box>
    )
  },
)
